// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/state-in-constructor, no-console, react/destructuring-assignment, react/jsx-handler-names, no-negated-condition, new-cap, babel/new-cap */
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components" // eslint-disable-line no-restricted-imports
import type { Dispatch } from "redux"
import Textarea from "@kiwicom/orbit-components/lib/Textarea"
import Button from "@kiwicom/orbit-components/lib/Button"

const FlexWrapper = styled.div`
  display: flex;
`

const ButtonWrapper = styled.div`
  margin: auto 0 0 0;
`

const IsJsonString = (str: string) => {
  try {
    JSON.parse(str)
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    return false
  }
  return true
}

type Props = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  splitster: any
}

type State = {
  splitsterConfig: string
}

class SaveLoadSplitster extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      splitsterConfig: JSON.stringify(props.splitster.getSaveResults()),
    }
  }

  setSplitster = () => {
    const {
      props: { dispatch },
      state: { splitsterConfig },
    } = this
    try {
      const cfg = JSON.parse(splitsterConfig)
      const entries = Object.entries(cfg)
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      entries.forEach(([testId, variantId]: [any, any]) =>
        dispatch({ type: "splitster/SET", payload: { testId, variantId, cookies: true } }),
      )
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      console.error(err)
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  changeSplitsterConfig = (e: React.ChangeEvent<any>) => {
    this.setState({ splitsterConfig: e.target.value })
  }

  render() {
    return (
      <>
        <h4>Copy/Paste tests setting</h4>
        <FlexWrapper>
          <Textarea
            value={this.state.splitsterConfig}
            onChange={this.changeSplitsterConfig}
            dataTest="splitster-config"
            help={!IsJsonString(this.state.splitsterConfig) ? "invalid JSON" : ""}
          />
          <ButtonWrapper>
            <Button
              onClick={this.setSplitster}
              fullWidth={false}
              type="primary"
              size="normal"
              disabled={!IsJsonString(this.state.splitsterConfig)}
            >
              Set
            </Button>
          </ButtonWrapper>
        </FlexWrapper>
      </>
    )
  }
}

export default connect((state) => ({
  // @ts-expect-error: Flow to TS migration.
  splitster: state.splitster,
}))(SaveLoadSplitster)
